import React, { useEffect, useRef, useState } from 'react'
import { Select, Spin } from 'antd'

export function SelectLandings({
  value: selectedLandings,
  template,
  onChange,
}) {
  const timeout = useRef()
  const [loading, setLoading] = useState(false)
  const [landings, setLandings] = useState([])
  const noResults = !loading && landings.length === 0 ? 'No results' : ''
  const loadingMsg = loading ? <Spin /> : ''

  async function searchLandings(query) {
    setLoading(true)
    setLandings(await fetchLanding({ query, template }))
    setLoading(false)
  }

  // Clear debounce fn on unmount
  useEffect(() => () => clearTimeout(timeout.current), [])

  return (
    <Select
      mode="multiple"
      size="medium"
      filterOption={false}
      defaultValue={
        selectedLandings.length === 0 ? undefined : selectedLandings
      }
      allowClear
      notFoundContent={noResults || loadingMsg || null}
      onSearch={(text) => {
        clearTimeout(timeout.current)
        timeout.current = setTimeout(() => searchLandings(text), 320)
      }}
      style={{ width: '100%' }}
      onChange={onChange}
    >
      {landings.map((s) => {
        return (
          <Select.Option key={s.id} value={s.id}>
            {s.title}
            <small
              style={{
                color: 'grey',
                fontStyle: 'italic',
              }}
            >
              {' '}
              - {s.id}
            </small>
          </Select.Option>
        )
      })}
    </Select>
  )
}

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'x-country': 'es',
  'x-shop': 'vinissimus',
}

async function fetchLanding({ query, template }) {
  const body = {
    query: {
      bool: {
        must: [
          {
            prefix: {
              path: '/landings/',
            },
          },
          {
            range: {
              depth: {
                gte: 3,
              },
            },
          },
        ],
        should: [
          {
            match: {
              title: {
                query,
                fuzziness: 'AUTO',
                max_expansions: 15,
              },
            },
          },
          {
            match_phrase_prefix: {
              title: {
                query,
                boost: 2,
              },
            },
          },
        ],
        minimum_should_match: 1,
      },
    },
    from: 0,
    size: 15,
  }

  if (template) {
    body.query.bool.must.push({
      match: {
        template: {
          query: template,
        },
      },
    })
  }

  const res = await fetch(`/db/guillotina/@search`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  const result = await res.json()

  return result.member
}
